let canNativeShare = false;
try {
	canNativeShare = navigator.canShare({
		text: "",
	});
} catch (err) {
	canNativeShare = false;
}
export default canNativeShare;
